<template>
	<div class="im-service-chating">
		<virtual-list class="list-infinite scroll-touch"
		  :data-key="'session_id'"
		  :data-sources="lists"
		  :estimate-size="91"
		  :data-component="itemComponent"
		  :item-class="'list-item-infinite'"
		>
		<div slot="footer" class="loading-toobar">
			<el-button type="text" disabled  :loading="loadStatus == 2">{{loadText[loadStatus]}}</el-button>
		</div>
		</virtual-list>
	</div>    
</template>
<script>
	import dialogueItem from './dialogue-item.vue';
	import { formatTalkUser } from '@/utils/imService';
	import {mapState} from 'vuex';
	export default {
		data(){
			return {
				itemComponent:dialogueItem,
				loadText:{
					'1':'未加载',
					'2':'加载中',
					'3':'没有更多数据',
					'4':'加载失败'
				}
			}
		},
		computed:{
			...mapState({
				lists:state => state.imChatService.items,
				loadStatus:state => state.imChatService.loadStatus
			})
		},
		created() {
			this.$store.dispatch('imChatService/load_talk_items')
		}
	}
</script>
<style lang="scss" scoped>
	.im-service-chating {
		width: 100%;
		height:100%;
		font-size: 14px;
		.scroll-touch {
			height: 100%;
			overflow: scroll;
		}
		.loading-toobar {
			display: flex;
			justify-content: center;
		}
	}
</style>